import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ChatManagerInstance from "./ChatManager";
import BaseSession from "./BaseSession";
import * as log from "loglevel";
import FirebaseChatSession from "./FirebaseChatSession";
import HttpStatus from "http-status-codes";

var ChatSession = /*#__PURE__*/function (_BaseSession) {
  _inherits(ChatSession, _BaseSession);

  function ChatSession(userName, roomName, accessToken) {
    var _this;

    _classCallCheck(this, ChatSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChatSession).call(this, userName, accessToken));
    _this.roomName = roomName.toLowerCase();
    return _this;
  }

  _createClass(ChatSession, [{
    key: "buildFirebaseSession",
    value: function buildFirebaseSession() {
      return new FirebaseChatSession(this.userName, this.roomName, this._id);
    }
  }, {
    key: "handleErrorResponse",
    value: function handleErrorResponse(response) {
      if (response.status === HttpStatus.FORBIDDEN) {
        throw new Error("Not Authorized");
      }

      if (response.ok) {
        return;
      }

      throw new Error("Server error");
    }
  }, {
    key: "attachRoomStateListener",
    value: function attachRoomStateListener() {
      var _this2 = this;

      log.trace("attach internal Room state listener");
      this.firebaseSession.attachRoomStateListener(function (roomState) {
        var event = {};

        if (roomState == null) {
          log.trace("room closed");
          event.type = "ROOM_CLOSED";
        } else {
          log.trace("room state updated: " + JSON.stringify(roomState));
          event.type = "ROOM_STATE_UPDATE";
          event.data = roomState;
        }

        if (_this2.roomStateListener) {
          _this2.roomStateListener(event);
        }
      });
    }
  }, {
    key: "setRoomStateListener",
    value: function setRoomStateListener(listener) {
      log.trace("attach external Room state listener");

      if (this.roomStateListener === void 0) {
        this.roomStateListener = listener;
        this.attachRoomStateListener();
        return;
      }

      this.roomStateListener = listener;
    }
  }, {
    key: "setRoomRosterListener",
    value: function setRoomRosterListener(externalRoomRosterListener) {
      log.trace("attach external Room roster listener");
      this.firebaseSession.attachRoomRosterListener(function (event) {
        log.trace("room roster event" + JSON.stringify(event));
        externalRoomRosterListener(event);
      });
    }
  }, {
    key: "setRoomUsersCountListener",
    value: function setRoomUsersCountListener(externalRoomUsersCountListener) {
      log.trace("attach external Room users counts listener");
      this.firebaseSession.attachRoomUsersCountListener(function (userCount) {
        log.trace("room user count changed event" + JSON.stringify(userCount));
        externalRoomUsersCountListener(userCount);
      });
    }
  }, {
    key: "setRoomMessagesListener",
    value: function setRoomMessagesListener(externalRoomMessagesListener) {
      log.trace("attach external Room last message listener");
      this.firebaseSession.attachRoomMessagesListener(function (roomMessage) {
        log.trace("room messages event" + JSON.stringify(roomMessage));
        externalRoomMessagesListener(roomMessage);
      });
    }
  }, {
    key: "setConnectionListener",
    value: function setConnectionListener(connectionListener) {
      this.firebaseSession.attachConnectionListener(function (event) {
        log.trace("connection event" + JSON.stringify(event));
        connectionListener(event);
      });
    }
  }, {
    key: "getAPIRequestFirebaseAccessURL",
    value: function getAPIRequestFirebaseAccessURL() {
      return ChatManagerInstance.restApiURL + "/rooms/" + this.roomName + "/access?username=" + this.userName;
    }
  }, {
    key: "getAPIMessagesURL",
    value: function getAPIMessagesURL() {
      return ChatManagerInstance.restApiURL + "/rooms/" + this.roomName + "/messages";
    }
  }, {
    key: "updateRoom",
    value: function updateRoom(status, custom, updateRoomHandler) {
      this.writeRoom(false, status, custom, updateRoomHandler);
    }
  }, {
    key: "createRoom",
    value: function createRoom(status, custom, createRoomHandler) {
      this.writeRoom(true, status, custom, function (error) {
        createRoomHandler(error);
      });
    }
  }, {
    key: "leaveRoom",
    value: function leaveRoom(leaveRoomHandler) {
      this.firebaseSession.detachListeners();
      this.firebaseSession.removePresenceNode(function (error) {
        if (leaveRoomHandler) {
          leaveRoomHandler(error);
        }
      });
    }
  }, {
    key: "addToPresenceNode",
    value: function addToPresenceNode(addToPresenceNodeHandler) {
      this.firebaseSession.addUserToPresenceNode(this.accessToken, function (error) {
        addToPresenceNodeHandler(error);
      });
    }
  }, {
    key: "createAndJoinRoom",
    value: function createAndJoinRoom(status, custom, createAndJoinRoomHandler) {
      var _this3 = this;

      this.firebaseSession.addUserToPresenceNode(this.accessToken, function (error) {
        if (error) {
          createAndJoinRoomHandler(error);
          return;
        }

        _this3.writeRoom(true, status, custom, function (error2) {
          createAndJoinRoomHandler(error2);
        });
      });
    }
  }, {
    key: "joinRoom",
    value: function joinRoom(joinRoomHandler) {
      var _this4 = this;

      ChatManagerInstance.checkRoomOnline(this.roomName, this.accessToken, function (status, error) {
        if (error) {
          joinRoomHandler(error);
          return;
        }

        if (!status.online) {
          joinRoomHandler("room Offline!");
          return;
        }

        _this4.firebaseSession.addUserToPresenceNode(_this4.accessToken, function (error2) {
          if (error2) {
            joinRoomHandler(error2);
            return;
          }

          joinRoomHandler(error2);
        });
      });
    }
  }, {
    key: "writeRoom",
    value: function writeRoom(isCreateOperation, status, custom, writeRoomHandler) {
      var url = ChatManagerInstance.getAPIRoomsURL();
      var createRoomData = {
        roomName: this.roomName,
        status: status,
        type: "ONLINE",
        custom: custom
      };
      var method = "POST";

      if (!isCreateOperation) {
        method = "PUT";
        url = ChatManagerInstance.getAPISpecificRoomURL(this.roomName);
      }

      this.doAPIRequest(url, method, createRoomData, writeRoomHandler);
    }
  }, {
    key: "writeMessage",
    value: function writeMessage(message) {
      this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
        message: message
      });
    }
  }, {
    key: "writeCustomMessage",
    value: function writeCustomMessage(message) {
      this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
        message: message,
        type: "CUSTOM"
      });
    }
  }, {
    key: "closeRoom",
    value: function closeRoom(closeRoomHandler) {
      this.doAPIRequest(ChatManagerInstance.getAPISpecificRoomURL(this.roomName), "DELETE", {}, closeRoomHandler);
    }
  }]);

  return ChatSession;
}(BaseSession);

export { ChatSession as default };